<template>
  <AppAsideDialog
    v-if="authStore.userContext"
    v-bind="{ isOpened }"
    @close="close"
  >
    <span class="mb-8 flex gap-2 pr-8 text-blue-700">
      <UserIcon class="h-6 w-6" />
      <span v-if="authStore.user" class="font-semibold">{{
        authStore.user.display ||
        authStore.user.email ||
        authStore.user.username
      }}</span>
    </span>

    <section class="mb-6 flex flex-col items-start rounded-xl bg-gray-100 p-5">
      <header class="mb-6 flex items-center gap-2 text-gray-500">
        <WalletIcon class="h-6 w-6" />
        <IntlMsg v-bind="{ k: 'account.balance' }" />
      </header>

      <MoneyWrap
        v-bind="{
          number: authStore.userContext?.balance,
          currencyClass: 'text-2xl leading-4 relative -top-0.5',
          integerClass: 'leading-4 font-bold',
        }"
        class="mb-5 flex items-baseline text-5xl font-medium leading-4 tracking-tight"
      />
      <AppLink
        v-bind="{ to: authStore.userContext.balanceLink + '#balance' }"
        class="c-btn c-btn--blue c-btn--md inline-flex items-center gap-2"
        @click="close"
      >
        <PlusIcon class="-ml-2.5 h-6 w-6 stroke-2" />
        <IntlMsg
          v-bind="{
            k: 'account.top-up',
          }"
          class="truncate"
        />
      </AppLink>
    </section>

    <nav class="mb-7">
      <AppLink
        v-if="authStore.userContext.is_staff"
        v-bind="{ to: '/admin/' }"
        class="flex items-center justify-between gap-4 rounded-none border-b-2 border-gray-100 py-3 text-xl font-semibold leading-7"
      >
        <IntlMsg v-bind="{ k: 'menu.admin-panel' }" />

        <ChevronRightIcon class="mr-0.5 h-6 w-6 shrink-0 stroke-2" />
      </AppLink>
      <AppLink
        v-if="authStore.userContext.is_staff"
        v-bind="{ to: '/my2/' }"
        class="flex items-center justify-between gap-4 rounded-none border-b-2 border-gray-100 py-3 text-xl font-semibold leading-7 text-blue-500"
      >
        Dashboard v2

        <span
          class="mr-2 rounded-full border border-amber-300 bg-amber-50 px-3 py-1 text-base leading-4 text-amber-950"
          >test</span
        >
      </AppLink>
      <AppLink
        v-for="(item, i) in authStore.navItems?.filter(
          x => !x.url.includes('logout')
        )"
        :key="i"
        v-bind="{ to: item.url }"
        class="flex items-center justify-between gap-4 rounded-none border-b-2 border-gray-100 py-3 text-xl font-semibold leading-7 last:border-b-0"
        @click="close"
      >
        {{ item.text }}

        <ChevronRightIcon class="mr-0.5 h-6 w-6 shrink-0 stroke-2" />
      </AppLink>
    </nav>

    <button
      class="c-btn c-btn--gray c-btn--md max-w-full self-start"
      @click="logout"
    >
      <IntlMsg
        v-bind="{
          k: 'menu.logout-from-account',
        }"
        class="truncate"
      />
    </button>
  </AppAsideDialog>
</template>

<script lang="ts" setup>
import { onUnmounted, ref } from 'vue'
import {
  PlusIcon,
  ChevronRightIcon,
  WalletIcon,
} from '@heroicons/vue/24/outline'
import { UserIcon } from '@heroicons/vue/20/solid'

import { bus, IntlMsg, MoneyWrap } from '/@shared/app'
import { AppAsideDialog, AppLink } from '/@app'

import { useAuthStore } from '/@/stores'

const authStore = useAuthStore()

const isOpened = ref(false)

function close() {
  isOpened.value = false
}
function open() {
  isOpened.value = true
}

function logout() {
  close()
  authStore.logout()
}

bus.on('app::show-mobile-account-menu', open)
onUnmounted(() => bus.off('app::show-mobile-account-menu', open))
</script>
